export const SRI = {
  USER_SCORE: { type: 'score_breakdown', sections: 'SCORE BREAKDOWN' },
  COMPANY_VIEWS: { type: 'company_views_graph', sections: 'COMPANY VIEWS' },
  PEOPLE_VIEWS: { type: 'people_views_graph', sections: 'PEOPLE VIEWS' },
  ARTICLES_READ: { type: 'articles_read_graph', sections: 'ARTICLES READ' },
  PLATFORM_SESSIONS: { type: 'platform_sessions_graph', sections: 'PLATFORM SESSIONS' },
  EMAILS_OPENED: { type: 'emails_opened_graph', sections: 'EMAILS OPENED' },
  ENGAGEMENT: { type: 'engagement', sections: 'ENGAGEMENT' },
};
